import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';

export default function UserFormModal({ user, onSuccess, onCancel }) {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    is_admin: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || '',
        email: user.email || '',
        password: '',
        is_admin: user.is_admin || false,
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (user) {
        // Update - only send password if it's filled
        const updateData = {
          username: formData.username,
          email: formData.email,
          is_admin: formData.is_admin,
        };
        if (formData.password) {
          updateData.password = formData.password;
        }
        await axios.put(`${API}/admin/users/${user.id}`, updateData);
        toast.success('User updated!');
      } else {
        // Create
        await axios.post(`${API}/admin/users`, formData);
        toast.success('User created!');
      }
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Operation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ background: 'rgba(0, 0, 0, 0.9)' }}
      onClick={onCancel}
    >
      <div
        className="retro-panel w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-3xl font-bold mb-6 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
          {user ? '[EDIT USER]' : '[CREATE USER]'}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
              Username:
            </label>
            <input
              type="text"
              name="username"
              data-testid="user-username-input"
              value={formData.username}
              onChange={handleChange}
              className="retro-input w-full"
              required
            />
          </div>

          <div>
            <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
              Email:
            </label>
            <input
              type="email"
              name="email"
              data-testid="user-email-input"
              value={formData.email}
              onChange={handleChange}
              className="retro-input w-full"
              required
            />
          </div>

          <div>
            <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
              Password {user ? '(leave blank to keep current)' : ''}:
            </label>
            <input
              type="password"
              name="password"
              data-testid="user-password-input"
              value={formData.password}
              onChange={handleChange}
              className="retro-input w-full"
              required={!user}
            />
          </div>

          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              name="is_admin"
              data-testid="user-admin-checkbox"
              checked={formData.is_admin}
              onChange={handleChange}
              className="w-5 h-5"
              style={{ accentColor: '#FF6B00' }}
            />
            <label className="text-lg font-semibold" style={{ color: '#ffffff' }}>
              Admin Privileges
            </label>
          </div>

          <div className="flex gap-4 pt-4">
            <button
              type="submit"
              data-testid="user-submit-button"
              className="retro-btn retro-btn-green flex-1"
              disabled={loading}
            >
              {loading ? '[PROCESSING...]' : user ? '[UPDATE]' : '[CREATE]'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              data-testid="user-cancel-button"
              className="retro-btn retro-btn-magenta flex-1"
            >
              [CANCEL]
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}